export default "__VITE_ASSET__DXYza$sW__"